<template>
  <div id="photos">
    <headNav :routeAddress="address">
      <div slot="headNavText">{{$t('message.basc_info')}}</div>
    </headNav>
    <div class="container">
      <div class="bascInfoBox">
        <div>
          <div class="circle circle1">01</div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
        </div>
        <div class="scsf">
          <div>{{$t('message.photo_rz')}}</div>
          <div>{{$t('message.photo_rz_tip')}}</div>
        </div>
        <div class="bascInfoContent">
          <div class="photo_border" style="margin-top: 0.4rem">
            <van-uploader v-model="IDcardZM" :max-count="1" :after-read="compressImgZM" class="sfzzm scsfz">
              <img src="../../../assets/images/3x/sfzzm.png" alt="">
            </van-uploader>
            <div class="text">{{$t('message.IDcardZM')}}</div>
          </div>

          <div class="photo_border" style="margin-top: 0.4rem">
            <van-uploader v-model="IDcardFM" :max-count="1" :after-read="compressImgFM" class="sfzfm scsfz">
              <img src="../../../assets/images/3x/sfzfm.png" alt="">
            </van-uploader>
            <div class="text">{{$t('message.IDcardFM')}}</div>
          </div>
          <!--          <div class="photo_border" style="margin-top: 0.4rem">-->
          <!--            <van-uploader v-model="HoldIDcardZM" :max-count="1" :after-read="compressImgholdZM" class="scsfz" capture="user">-->
          <!--              <img src="../../../assets/images/index/face.png" alt="" style="width: 2.3rem">-->
          <!--            </van-uploader>-->
          <!--            <div class="text">Nhận diện khuôn mặt</div>-->
          <!--          </div>-->
          <div class="intro">
            <h3>{{$t('message.psyq')}}</h3>
            <div>{{$t('message.psyq_sfz')}} <span>{{$t('message.psyq_sfz_bk')}}</span></div>
            <div class="yt_area">
              <div class="yt_area_item">
                <img src="../../../assets/images/3x/y1.png" alt="">
                <p>{{$t('message.bz')}}</p>
              </div>
              <div class="yt_area_item">
                <img src="../../../assets/images/3x/y2.png" alt="">
                <p>{{$t('message.bkqs')}}</p>
              </div>
              <div class="yt_area_item">
                <img src="../../../assets/images/3x/y3.png" alt="">
                <p>{{$t('message.zpmh')}}</p>
              </div>
              <div class="yt_area_item">
                <img src="../../../assets/images/3x/y4.png" alt="">
                <p>{{$t('message.sgql')}}</p>
              </div>
            </div>
          </div>
          <van-button type="primary" size="normal" round @click="nextStep" v-if="isRest==null" class="btns" block>{{$t('message.yys_sub')}}
          </van-button>
          <van-button type="primary" size="normal" round @click="restNextStep" v-if="isRest!=null" class="btns" block>
            {{$t('message.jx')}}
          </van-button>
        </div>
      </div>
    </div>
    <div class="deal_photo"></div>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  import {hongkPostImg, idcard_verify} from '../../../ports/port'
  import {postAli} from '../../../ports/port'
  import {isPhotosAll} from '../../../ports/port'
  import {postUserInfo, sassSearchPhoto} from '../../../ports/port'
  import * as imageConversion from 'image-conversion';
  import $ from 'jquery'
  // import {compress, compressAccurately} from 'image-conversion';

  export default {
    name: "photos",
    data() {
      return {
        IDcardZM: [],//身份证正面
        IDcardFM: [],//身份证反面
        HoldIDcardZM: [],//手持身份证正码
        work: [],//工作证
        IDcardZMUrl: '',
        IDcardFMUrl: '',
        HoldIDcardZMUrl: '',
        workUrl: '',
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        upload_file: "",
        isRest: '',//判断是否审核拒绝，需要重新认证
        address:'/home/editBascInfo'
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      postUserInfo({userid: this.tk.userid})
        .then(res => {
          if (res.data.code == 200) {
            res.data.data.userIdcard == null || res.data.data.userIdcard == "" ? this.IDcardZM : this.IDcardZM = [{url: res.data.data.userIdcard}];
            this.IDcardZMUrl = res.data.data.userIdcard;

            res.data.data.url_photoliving == null || res.data.data.url_photoliving == "" ? this.HoldIDcardZM : this.HoldIDcardZM = [{url: res.data.data.url_photoliving}];
            this.HoldIDcardZMUrl = res.data.data.url_photoliving;

            res.data.data.employment_Pass == null || res.data.data.employment_Pass == "" ? this.work : this.work = [{url: res.data.data.employment_Pass}];
            this.workUrl = res.data.data.employment_Pass;

            res.data.data.url_backcard == null || res.data.data.url_backcard == "" ? this.IDcardFM : this.IDcardFM = [{url: res.data.data.url_backcard}];
            this.IDcardFMUrl = res.data.data.url_backcard;


            if (sessionStorage.getItem("imgUrl1") != null) {
              this.IDcardZMUrl = sessionStorage.getItem("imgUrl1");
              this.IDcardZM = [{url: sessionStorage.getItem("baseimgUrl1"), isImage: true}];
              $(".sfzzm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl1"));
            } else {

            }
            if (sessionStorage.getItem("imgUrl2") != null) {
              this.IDcardFMUrl = sessionStorage.getItem("imgUrl2");
              this.IDcardFM = [{url: sessionStorage.getItem("baseimgUrl2"), isImage: true}];
              $(".sfzfm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl2"));
            } else {
              // this.IDcardFM=[{url:sessionStorage.getItem("imgUrl2")}];
              // $(".sfzfm").find(".van-image__img").attr("src",this.IDcardFM);
            }
          } else {
            if (sessionStorage.getItem("imgUrl1") != null) {
              this.IDcardZMUrl = sessionStorage.getItem("imgUrl1");
              this.IDcardZM = [{url: sessionStorage.getItem("baseimgUrl1"), isImage: true}];
              $(".sfzzm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl1"));
            } else {

            }
            if (sessionStorage.getItem("imgUrl2") != null) {
              this.IDcardFMUrl = sessionStorage.getItem("imgUrl2");
              this.IDcardFM = [{url: sessionStorage.getItem("baseimgUrl2"), isImage: true}];
              $(".sfzfm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl2"));
            } else {
            }
          }
        })

      //通过验证后，重新修改数据
      this.isRest = sessionStorage.getItem('restRZ');
      if (sessionStorage.getItem('restRZ')) {
        sassSearchPhoto({userid: this.tk.userid, orderid: this.$route.query.orderid})
          .then(res => {
            if (res.data.code == 200) {
              this.IDcardZM = [{url: res.data.data.url_frontcard}];
              this.IDcardFM = [{url: res.data.data.url_backcard}];
              this.HoldIDcardZM = [{url: res.data.data.url_photoliving}];

              if (sessionStorage.getItem("imgUrl1") != null) {
                this.IDcardZMUrl = sessionStorage.getItem("imgUrl1");
                this.IDcardZM = [{url: sessionStorage.getItem("imgUrl1")}];
                $(".sfzzm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl1"));
              } else {

              }
              if (sessionStorage.getItem("imgUrl2") != null) {
                this.IDcardFMUrl = sessionStorage.getItem("imgUrl2");
                this.IDcardFM = [{url: sessionStorage.getItem("imgUrl2")}];
                $(".sfzfm").find(".van-image__img").eq(0).attr("src", sessionStorage.getItem("imgUrl2"));
              } else {
                // this.IDcardFM=[{url:sessionStorage.getItem("imgUrl2")}];
                // $(".sfzfm").find(".van-image__img").attr("src",this.IDcardFM);
              }

            } else {

            }

          })
          .catch(err=>{
            this.$store.commit('edit',false);//关闭全局的loading
            if(err.toString().indexOf('timeout')!=-1){
              this.$toast({message:this.$t("message.service_timeout"),type:'danger',icon:'fail'});
            }
          })
      }


    },
    components: {
      headNav
    },
    methods: {
      getImageBase64(blob) {
        return new Promise((resolve,reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          let width;
          let height;
          reader.onload = (e) => {
            const base64 = reader.result;
            resolve(base64);
          };
          reader.onerror = error => reject(error);
        });
      },
      getImageWidthHeight(blob) {
        return new Promise((resolve,reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          let width;
          let height;
          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = function() {
              width = this.width;
              height = this.height;
              resolve({'width':width,'height':height});
            };
          };
          reader.onerror = error => reject(error);
        });
      },
      compressImgZM(file) {
        const toast = this.$toast({duration:0,message:this.$t('message.upload_scz'),forbidClick:true});
        // 此时可以自行将文件上传至服务器
        if (file) {
          let _this = this;
          let imageWidth;
          let imageHeight;
          this.getImageWidthHeight(file.file).then(res=> {
            if (res.width > res.height) {
              imageWidth = 1200;
              imageHeight = parseInt((1200 * res.height) / res.width);
            } else {
              imageHeight = 1200;
              imageWidth = parseInt((1200 * res.width) / res.height);
            }
            imageConversion.compressAccurately(file.file,{size:380,width:imageWidth,height:imageHeight}).then(res=>{
              this.getImageBase64(res).then((base64)=>{
                sessionStorage.setItem("sfzzm", base64);
                hongkPostImg({userid: _this.tk.userid, img: base64, imgname: 'img1'})
                  .then(res => {
                    if (res.data.code == 200) {
                      _this.IDcardZMUrl = res.data.data.url;
                      sessionStorage.setItem("baseimgUrl1",base64);
                      sessionStorage.setItem("imgUrl1", res.data.data.url);
                      sessionStorage.setItem("birthdate",res.data.data.date);
                      this.$notify({type: 'success', message: res.data.msg});//图片上传不成功，请重新上传
                      // file.status = 'done';
                    } else {
                      _this.$notify({type: 'danger', message: res.data.msg});//图片上传不成功，请重新上传
                    }
                    toast.clear();
                  })
                  .catch(res=>{
                    toast.clear();
                    this.$toast({duration:2000,message:'Network Error'})
                  })
              })
            });
          });

        }
      },
      compressImgFM(file) {
        const toast = this.$toast({duration:0,message:this.$t('message.upload_scz'),forbidClick:true});
        // 此时可以自行将文件上传至服务器
        if (file) {
          let _this = this;
          let imageWidth;
          let imageHeight;
          this.getImageWidthHeight(file.file).then(res=> {
            if (res.width > res.height) {
              imageWidth = 1200;
              imageHeight = parseInt((1200 * res.height) / res.width);
            } else {
              imageHeight = 1200;
              imageWidth = parseInt((1200 * res.width) / res.height);
            }
            imageConversion.compressAccurately(file.file,{size:380,width:imageWidth,height:imageHeight}).then(res=>{
              //The res in the promise is a compressed Blob type (which can be treated as a File type) file;
              this.getImageBase64(res).then((base64)=>{
                sessionStorage.setItem("sfzzm", base64);
                // _this.$router.push({path: "/photos/dealPhoto", query: {img: 'img2'}})
                hongkPostImg({userid: _this.tk.userid, img: base64, imgname: 'img2'})
                  .then(res => {
                    if (res.data.code == 200) {
                      _this.IDcardFMUrl = res.data.data.url;
                      sessionStorage.setItem("baseimgUrl2",base64);
                      sessionStorage.setItem("imgUrl2", res.data.data.url);
                      _this.$notify({type: 'success', message: res.data.msg});//图片上传不成功，请重新上传
                    } else {
                      _this.$notify({type: 'danger', message: res.data.msg});//图片上传不成功，请重新上传
                    }
                    toast.clear();
                  })
                  .catch(res=>{
                    toast.clear();
                    this.$toast({duration:2000,message:'Network Error'})
                  })
              })
            });
          });
        }
      },
      compressImgholdZM(file) {
        // 此时可以自行将文件上传至服务器
        if (file) {
          let _this = this;
          file.status = 'uploading';
          file.message = this.$t('message.upload_scz');
          let quality =1;
          if(file.file.size<200000){
            quality=1;
          }else{
            quality = parseInt((200000/file.file.size)*1000+2)/1000;
            if(quality<0.1){
              quality = 0.1;
            }
          }
          lrz( file.file,{quality:quality})
            .then(function (rst) {
              hongkPostImg({userid: _this.tk.userid, img: rst.base64, imgname: 'img3'})
                .then(res => {
                  if (res.data.code == 200) {
                    _this.HoldIDcardZMUrl = res.data.data.url;
                    file.status = 'done';
                  } else {
                    _this.$notify({type: 'danger', message: res.data.msg});//图片上传不成功，请重新上传
                    file.status = 'failed';
                    file.message = _this.$t('message.upload_scz_error');
                  }
                })
            }).catch(function (error) {
            //失败时执行
            // _this.$notify({type: 'danger', message: _this.$t('message.img_ys_error')});//图片压缩失败
          }).always(function () {
            //不管成功或失败，都会执行
          })
        }
      },
      compressImgWork(file) {
        if (file) {
          let _this = this;
          file.status = 'uploading';
          file.message = this.$t('message.upload_scz');
          let quality =1;
          if(file.file.size<200000){
            quality=1;
          }else{
            quality = parseInt((200000/file.file.size)*1000+2)/1000;
            if(quality<0.1){
              quality = 0.1;
            }
          }
          lrz( file.file,{quality:quality})
            .then(function (rst) {
              hongkPostImg({userid: _this.tk.userid, img: rst.base64, imgname: 'employment_Pass'})
                .then(res => {
                  if (res.data.code == 200) {
                    _this.workUrl = res.data.data;
                    file.status = 'done';
                  } else {
                    _this.$notify({type: 'danger', message: _this.$t('message.img_upload_agagin')});//图片上传不成功，请重新上传
                    file.status = 'failed';
                    file.message = _this.$t('message.upload_scz_error');
                  }
                })
            }).catch(function (error) {
            //失败时执行
            // _this.$notify({type: 'danger', message: _this.$t('message.img_ys_error')});//图片压缩失败
          }).always(function () {
            //不管成功或失败，都会执行
          })
        }
      },
      nextStep() {
        if(sessionStorage.getItem('baseimgUrl1')!=null && sessionStorage.getItem('baseimgUrl2')!=null) {
          this.$router.push({path: '/face_intro'});
        }else{
          this.$notify({
            type: 'danger',
            message: this.$t('message.upLoad_image_no')
          });
        }
      },
      restNextStep() {

        if (this.IDcardZM.length != 0 && this.IDcardFM.length != 0 && this.HoldIDcardZM.length != 0) {
          let restRZ = {
            orderid: this.$route.query.orderid,
            type: 2,
            contacts_info: '',//通讯录信息，h5传空
            url_frontcard: this.IDcardZM[0].url || sessionStorage.getItem("imgUrl1"),
            url_backcard: this.IDcardFM[0].url || sessionStorage.getItem("imgUrl2"),
            url_photoliving: this.HoldIDcardZM[0].url || this.HoldIDcardZMUrl,
          };
          localStorage.setItem('tempDate', JSON.stringify(restRZ));//暂存重新认证的数据
          this.$router.push({path: '/bascInfo', query: {orderid: this.$route.query.orderid}});
        } else {
          this.$notify({
            type: 'danger',
            message: this.$t('message.upLoad_image_no'),
          });
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .container{
    padding: 1.6rem 15px 0;
    .circle{
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }
    .circle1{
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }
    .scsf{
      & :nth-child(1){
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }
      & :nth-child(2){
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }
    }
    .bascInfoContent{
      .photo_border{
        background-color: #F4F8FE;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        height:4.15rem;
        width: 100%;
        text-align: center;
        /*padding-top: 0.5rem;*/
        box-sizing: border-box;
        .text{
          position: absolute;
          width: 100%;
          text-align: center;
          padding: 10px 0;
          color: #fff;
          background-color: $color;
          bottom: 0;
          left: 0;
        }
        img{
          width: 3.48rem;
        }
      }
      .intro{
        h3{
          font-size: 0.43rem;
          font-weight: 600;
          color:#333333;
          margin-top: 1.07rem;
          ~div{
            font-size: 0.35rem;
            color: #A3A3A3;
            span{
              color: #FF0000;
            }
          }
        }
        .yt_area{
          display: flex;
          margin-top: 0.67rem;
          .yt_area_item{
            display: flex;
            flex: 1;
            align-items: center;
            flex-direction: column;
            img{
              height: 1.45rem;
              margin-bottom: 6px;
            }
            p{
              font-size: 0.32rem;
              color:#A3A3A3 ;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .btns{
    @include defaultBtn
    margin: 0.75rem 0 1.12rem;
  }
  .scsfz,/deep/ .scsfz>.van-uploader__wrapper,/deep/ .scsfz>.van-uploader__wrapper>.van-uploader__input-wrapper{
    width: 100%;
    height: 100%;
  }
  .scsfz,.scsfz>.van-uploader__wrapper>.van-uploader__input-wrapper{
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 95;
  }
  /deep/.scsfz .van-uploader__preview{
    /*margin: 0 auto;*/
    width: 100%;
    margin: 0;
  }
  /deep/ .van-image__img{
    width: 100%;
  }
  /deep/ .van-uploader__preview-image{
    width: 100%;
    height: 100%;
    margin: 0!important;
  }
  /deep/ .van-uploader__input-wrapper img{
    padding-top: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/photos.vue